module.exports = __webpack_public_path__ + "img/add-more.aad26e56.png";